exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link {\r\n  margin-top: 6px;\r\n}", ""]);
